import React from 'react';
import {
  CheckboxInput,
  Datepicker,
  Input,
  SelectMultipleControlled,
} from '../../../../../components/form7';
import InputLabel from '../../../../../components/form/InputLabel';
import { FieldType } from '../../../__generated__/graphql';
import { FieldInfo } from '../types';

type Props = {
  fieldInfo: FieldInfo;
};

export const FieldInput7: React.FC<React.PropsWithChildren<Props>> = ({
  fieldInfo,
}) => {
  const inputProps = {
    name: fieldInfo.name,
    label: fieldInfo.label,
    hint: fieldInfo.hint,
    disabled: fieldInfo.disabled,
    required: fieldInfo.required,
    step: fieldInfo.step,
    onChange: (value: string | boolean) =>
      fieldInfo.onChange?.(value, fieldInfo),
  };

  switch (fieldInfo.type) {
    case FieldType.Boolean: {
      return <CheckboxInput {...inputProps} />;
    }
    case FieldType.Currency:
    case FieldType.Percent:
    case FieldType.Integer:
    case FieldType.Long:
    case FieldType.Double: {
      return <Input {...inputProps} type="number" />;
    }
    case FieldType.Time: {
      return <Input {...inputProps} type="time" />;
    }
    case FieldType.Date: {
      return <Datepicker {...inputProps} type="date" />;
    }
    case FieldType.Datetime: {
      return <Datepicker {...inputProps} type="datetime" />;
    }
    case FieldType.Picklist: {
      return (
        <Input {...inputProps} type="select">
          {fieldInfo.doNotInsertDefaultOptions !== true && <option></option>}
          {fieldInfo.options.map((entry, index) => (
            <option key={index} value={entry.value}>
              {entry.label}
            </option>
          ))}
        </Input>
      );
    }
    case FieldType.Multipicklist: {
      return (
        <div>
          <InputLabel label={fieldInfo.label} required={fieldInfo.required} />
          <SelectMultipleControlled
            name={fieldInfo.name}
            isDisabled={fieldInfo.options.length === 0 || fieldInfo.disabled}
            options={fieldInfo.options}
          />
        </div>
      );
    }
    case FieldType.Email: {
      return <Input {...inputProps} type="email" />;
    }
    case FieldType.Url: {
      return <Input {...inputProps} type="url" />;
    }
    case FieldType.Textarea: {
      return (
        <Input {...inputProps} minRows={fieldInfo.minRows} type="textarea" />
      );
    }
    case FieldType.Phone: {
      return <Input {...inputProps} type="tel" />;
    }
    default: {
      return <Input {...inputProps} />;
    }
  }
};
